"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RibbingSchema = void 0;
const yup = __importStar(require("yup"));
const ribbingAttributes_1 = require("../attributes/ribbingAttributes");
const shared = __importStar(require("./sharedSchemas"));
const types_1 = require("../types");
const utils_1 = require("./utils");
exports.RibbingSchema = yup
    .object({
    productType: shared.productTypeSchema(types_1.ProductTypes.Ribbing),
    sellingUnit: utils_1.reqSelectOneSchema(Object.values(ribbingAttributes_1.SellingUnit)),
    material: shared.contentSchema.required(),
    stretch: shared.stretchSchema,
    colour: shared.colourSchema,
    colourTone: shared.colourToneSchema,
    widthCM: shared.widthCMSchema,
    lengthCM: shared.widthLengthBaseSchema.min(1).max(250).required(),
    size: utils_1.reqSelectOneSchema(Object.values(ribbingAttributes_1.Size)),
    imperfections: shared.imperfectionsSchema.transform((val) => {
        if (val[0] instanceof Array)
            return val[0];
        return val;
    }),
    uses: shared.usesSchema,
    quantity: shared.quantitySchema.required(),
    packSize: shared.packSizeSchema,
    pattern: shared.patternSchema,
    price: shared.priceSchema
})
    .when('$product.sellingUnit', (sellingUnit, schema) => {
    switch (sellingUnit) {
        case ribbingAttributes_1.SellingUnit.Individual:
            return schema.omit(['packSize']);
        case ribbingAttributes_1.SellingUnit['Pack']:
            return schema;
        case ribbingAttributes_1.SellingUnit['By Meter']:
            return schema.omit(['packSize', 'lengthCM', 'size']);
        default:
            return schema;
    }
})
    .test('Context Check', "Ribbing Validator needs ribbing product in it's context", (_, context) => {
    var _a;
    if (!((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product))
        return false;
    return true;
})
    .required();
//# sourceMappingURL=ribbingSchema.js.map